// extracted by mini-css-extract-plugin
module.exports = {"cookiebox":"cookiebox_cookiebox__bBP_E","cookieboxInButtons":"cookiebox_cookieboxInButtons__6X_sk","showBanner":"cookiebox_showBanner__Q_0aE"};